import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import SubscriptionSetupContentSwitch from './SubscriptionSetupContentSwitch';

const styles = () => ({
  root: {},
});

const SubscriptionSetupContent = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {/* -------- Stripe -------- */}
      <SubscriptionSetupContentSwitch />
    </Box>
  );
};

SubscriptionSetupContent.defaultProps = {
  className: '',
};

SubscriptionSetupContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionSetupContent);
